import { useMsal } from "@azure/msal-react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const UserProfile = () => {
    const { accounts } = useMsal();
    const account = accounts[0];
    if (!account) {
        return (
            <h2>Cargando...</h2>
        );
    }
    return (
        <div>
            <Card variant="outlined">
                <CardContent>
                    <Typography gutterBottom variant="h4" component="div">
                        {account.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Id: {account.idTokenClaims.oid}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Email: {account.idTokenClaims.email}
                    </Typography>
                </CardContent>
            </Card>
        </div>
    );
}

export default UserProfile;